<div *ngIf="offers?.length > 1" class="promo-card h-100 w-100" [ngClass]="{'hide-offers': !isPlansVariation}">
  <div class="offers-section">
    <h2 class="plan-title">Choose Your Plan</h2>
    <div class="offers-container d-flex flex-column">
      <div class="button-card" *ngFor="let offer of offers; trackBy: trackById">
        <flo-offer-button-card [offer]="offer" [isMonthly]="offer.offerMetadata.period !== 'year'" (offerSelected)="onOfferSelected($event)"></flo-offer-button-card>
      </div>
   </div>
  </div>
  <div class="value-props-section">
    <h2 class="plans-subtitle">
      {{ sportName }} Live<span *ngIf="!isPlural">s</span> Here
    </h2>
    <div class="value-props-container">
        <flo-value-prop
          *ngFor="let bullet of filteredBullets; trackBy: trackById"
          [proposition]="bullet.text"
          [label]="'checkmark-primary'"
        ></flo-value-prop>

        <button 
          class="signup-btn btn btn-lg btn-primary lg-font-btn"
          (click)="onSignupSelected()"  
          data-test="signup-btn"
        >
          Sign Up
        </button>
    </div>
  </div>
</div>